<template>
  <search-wrapper :model="searchParams" @search="search">
    <label-input
      class="control"
      label="执业药师"
      labelWidth="100px"
      placeholder="请输入执业药师"
      width="330px"
      v-model="pharmacistName"
      prop="pharmacistName"
      :input-attr="{ maxlength: 50 }"
      clearable
    />
    <label-input class="control" label="执业类别" width="230px" prop="practiceCategory">
      <el-select v-model="practiceCategory" placeholder="请选择执业类别">
        <el-option
          v-for="item in practiceCategoryOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input
      class="control"
      label="注册证编号"
      labelWidth="100px"
      placeholder="请输入注册证编号"
      width="330px"
      v-model="practiceCertNo"
      prop="practiceCertNo"
      :input-attr="{ maxlength: 50 }"
      clearable
      valueKey="practiceCertNo"
    />
    <label-input class="control" label="注册证有效期至" width="435px" prop="dateRange">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :defaultTime="['00:00:00', '23:59:59']"
        valueFormat="yyyy-MM-dd HH:mm:ss"
        :clearable="false"
        align="right"
      ></el-date-picker>
    </label-input>
    <label-input class="control" label="注册证状态" label-width="120px" width="240px" prop="practiceCertStatus">
      <el-select v-model="practiceCertStatus" placeholder="请选择注册证状态">
        <el-option
          v-for="item in practiceCertStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input class="control" label="认证状态" width="230px" prop="auditStatus">
      <el-select v-model="auditStatus" placeholder="请选择注认证状态">
        <el-option
          v-for="item in auditStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input class="control" label="账号状态" width="230px" prop="userStatus">
      <el-select v-model="userStatus" placeholder="请选择账号状态">
        <el-option
          v-for="item in userStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>

    <!-- <el-button class="search-btn" @click="search">查询</el-button> -->
  </search-wrapper>
</template>

<script>
import dayjs from 'dayjs';
// import Fetch from '@/api';
import labelInput from '@/components/global/form/labelInputForSupervision';
import searchWrapper from '@/components/global/form/searchWrapper';

export default {
  name: 'searchBar',
  props: {
    searchParams: {
      type: Object,
      default: () => ({})
    },
    storeId: {
      type: Number || undefined
    }
  },
  components: {
    labelInput,
    searchWrapper
  },
  computed: {
    pharmacistName: {
      get() {
        return this.searchParams.pharmacistName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'pharmacistName',
          value: val
        });
      }
    },
    practiceCertNo: {
      get() {
        return this.searchParams.practiceCertNo;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'practiceCertNo',
          value: val
        });
      }
    },
    practiceCertStatus: {
      get() {
        return this.searchParams.practiceCertStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'practiceCertStatus',
          value: val
        });
      }
    },
    practiceCategory: {
      get() {
        return this.searchParams.practiceCategory;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'practiceCategory',
          value: val
        });
      }
    },
    auditStatus: {
      get() {
        return this.searchParams.auditStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'auditStatus',
          value: val
        });
      }
    },
    userStatus: {
      get() {
        return this.searchParams.userStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'userStatus',
          value: val
        });
      }
    },
    dateRange: {
      get() {
        return this.searchParams.dateRange;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'dateRange',
          value: val
        });
      }
    }, // riskType

    auditStatusOptions() {
      return [
        {
          label: '全部',
          value: null
        },
        {
          label: '未提交',
          value: 0
        },
        {
          label: '已认证',
          value: 1
        },
        {
          label: '待审核',
          value: 2
        },
        {
          label: '已驳回',
          value: 3
        }
      ];
    },
    practiceCategoryOptions() {
      return [
        { label: '全部', value: null },
        { label: '药学', value: 1 },
        { label: '中药学', value: 2 },
        { label: '药学与中药学', value: 3 }
      ];
    },
    practiceCertStatusOptions() {
      return [
        { label: '全部', value: null },
        { label: '正常', value: 1 },
        { label: '过期', value: 0 }
      ];
    },
    userStatusOptions() {
      return [
        { label: '全部', value: null },
        { label: '正常', value: 1 },
        { label: '已关闭', value: 0 }
      ];
    },
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: '昨日',
            onClick(picker) {
              const yesterday = dayjs().subtract(1, 'days');
              picker.$emit('pick', [
                yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本周',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本年',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          }
        ]
      };
    }
  },
  methods: {
    search() {
      this.$emit('search');
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;

  // .control {
  //   margin-right: 16px;
  //   margin-bottom: 10px;
  // }

  .zy-date-picker {
    margin-right: 16px;
    margin-bottom: 10px;
  }

  .search-btn {
    margin-bottom: 10px;
    height: 40px !important;
    width: 80px !important;
    color: #1e8dff !important;
    background: #ffffff !important;
    border: 1px solid #1e8dff !important;
    &:hover {
      background: rgba(68, 184, 91, 0.1) !important;
    }
  }

  /deep/.date-picker {
    border: unset;
    padding-right: 0;
  }
}
</style>
